// import React, { useState, useEffect, useRef } from "react";
// import {
//   FaUser,
//   FaSearch,
//   FaHeart,
//   FaShoppingBag,
//   FaBars,
//   FaSignInAlt,
//   FaUserPlus,
//   FaSignOutAlt,
//   FaBoxOpen,
//   FaTachometerAlt,
// } from "react-icons/fa";
// import { Link } from "react-router-dom";
// import { useAuth } from "../../context/AuthContext";
// import { useMenu } from "../../context/MenuContext"; // ✅ use global MenuContext
// import Logo from "../../../assets/images/logo/TYKA LOGO.png";
// import CartDrawer from "../cartpage/CartDrawer";
// import MegaMenu from "../mens/MegaMenu";
// import MegaMenuCricket from "../cricket/MegaMenuCricket";
// import MobileNavbar from "./MobileNavbar";
// import WishlistDrawer from "../../common/cartpage/WishlistDrawer";
// import SearchModal from "./SearchModal"; // create this component

// const Navbar = () => {
//   const [menuData, setMenuData] = useState([]);
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [cartOpen, setCartOpen] = useState(false);
//   const [showUserDropdown, setShowUserDropdown] = useState(false);
//   const [loadingMenu, setLoadingMenu] = useState(true);
//   const [menuError, setMenuError] = useState(null);
//   const [wishlistOpen, setWishlistOpen] = useState(false);
//   const [searchOpen, setSearchOpen] = useState(false);
//   const { cartCount, wishlistCount, fetchMenuCounts } = useMenu();
//   const { token, userName, logout } = useAuth();
//   const user = JSON.parse(localStorage.getItem("authUserId"));
//   const id = user;

//   const hideTimeoutRef = useRef(null);
//   const menuHideTimeoutRef = useRef(null);

//   const handleMouseEnter = () => {
//     clearTimeout(hideTimeoutRef.current);
//     setShowUserDropdown(true);
//   };

//   const handleMouseLeave = () => {
//     hideTimeoutRef.current = setTimeout(() => {
//       setShowUserDropdown(false);
//     }, 500);
//   };

//   const [activeMenu, setActiveMenu] = useState(null);

//   const handleMenuMouseEnter = (categoryId) => {
//     clearTimeout(menuHideTimeoutRef.current);
//     setActiveMenu(categoryId);
//   };

//   const handleMenuMouseLeave = () => {
//     menuHideTimeoutRef.current = setTimeout(() => {
//       setActiveMenu(null);
//     }, 300);
//   };

//   // 🔹 Fetch menu & counts once
//   useEffect(() => {
//     const fetchMenu = async () => {
//       try {
//         setLoadingMenu(true);
//         setMenuError(null);

//         const res = await fetch(
//           `https://tyka.premierhostings.com/backend/api/menu${
//             id ? `?id=${id}` : ""
//           }`,
//           {
//             headers: {
//               "Content-Type": "application/json",
//               ...(token ? { Authorization: `Bearer ${token}` } : {}),
//             },
//           }
//         );
//         if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
//         const data = await res.json();

//         setMenuData(data.data || []);
//         // ✅ update global counts
//         fetchMenuCounts(id, token);
//       } catch (err) {
//         setMenuError("Failed to load menu");
//       } finally {
//         setLoadingMenu(false);
//       }
//     };
//     fetchMenu();
//   }, [id, token, fetchMenuCounts]);

//   return (
//     <>
//       <header className="shadow-md sticky top-0 z-50 bg-white">
//         <div className="max-w-[1747px] mx-auto flex items-center justify-between px-4 py-3 md:px-6 md:py-4">
//           {/* Logo */}
//           <div className="flex items-center mr-4 md:mr-10">
//             <Link to="/">
//               <img
//                 src={Logo}
//                 alt="Logo"
//                 className="h-10 w-auto md:h-12"
//                 title="Tyka"
//               />
//             </Link>
//           </div>

//           {/* Mobile Hamburger */}
//           <div className="md:hidden">
//             <button onClick={() => setMenuOpen(true)}>
//               <FaBars size={22} />
//             </button>
//           </div>

//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex items-center space-x-10 text-sm font-semibold">
//             <Link to="#" className="hover:text-red-600" title="new arrivals">
//               NEW ARRIVALS
//             </Link>

//             {menuData.map((category) => {
//               const name = category.name.toUpperCase();
//               const subcategories = category.subcategories;

//               return (
//                 <div
//                   key={category.id}
//                   className="relative"
//                   onMouseEnter={() => handleMenuMouseEnter(category.id)}
//                   onMouseLeave={handleMenuMouseLeave}
//                 >
//                   <a href="" className="hover:text-red-600 flex items-center">
//                     {name}
//                     {subcategories.length > 0 && (
//                       <span className="ml-1">▾</span>
//                     )}
//                   </a>

//                   {activeMenu === category.id &&
//                     (subcategories.length === 3 ? (
//                       <MegaMenu subcategories={subcategories} category={name} />
//                     ) : subcategories.length === 1 ? (
//                       <MegaMenuCricket subcategories={subcategories} />
//                     ) : null)}
//                 </div>
//               );
//             })}

//             <Link
//               to="/design-your-own"
//               className="hover:text-red-600"
//               title="DESIGN YOUR OWN"
//             >
//               DESIGN YOUR OWN
//             </Link>
//           </nav>

//           {/* Right Icons */}
//           <div className="hidden md:flex items-center space-x-7 text-sm relative">
//             {/* 👤 USER DROPDOWN */}
//             <div
//               className="relative"
//               onMouseEnter={handleMouseEnter}
//               onMouseLeave={handleMouseLeave}
//             >
//               <div className="flex items-center space-x-2 cursor-pointer hover:text-red-600">
//                 <FaUser />
//                 {token && (
//                   <span className="text-sm font-medium" title={`${userName}`}>
//                     {userName}
//                   </span>
//                 )}
//               </div>

//               {showUserDropdown && (
//                 <div
//                   className="absolute bg-white shadow-md p-4 right-0 top-11 z-50"
//                   style={{ width: "200px", marginRight: "-55px" }}
//                 >
//                   {token ? (
//                     <>
//                       <p className="text-sm font-medium mb-4 flex items-center gap-2">
//                         Hi, {userName || "User"}!
//                       </p>
//                       <Link
//                         to={`/userdashboard/${id}`}
//                         className="flex items-center gap-2 mb-2 text-base"
//                         title="Dashboard"
//                       >
//                         <FaTachometerAlt /> Dashboard
//                       </Link>
//                       <Link
//                         to={`/userorder/${id}`}
//                         className="flex items-center gap-2 mb-2 text-base"
//                         title="Orders"
//                       >
//                         <FaBoxOpen /> Orders
//                       </Link>
//                       <Link
//                         to={`/userprofile/${id}`}
//                         className="flex items-center gap-2 mb-2 text-base"
//                         title="Profile"
//                       >
//                         <FaUser /> Profile
//                       </Link>
//                       <button
//                         onClick={logout}
//                         className="flex items-center gap-2 text-base text-red-400"
//                         title="Logout"
//                       >
//                         <FaSignOutAlt /> Logout
//                       </button>
//                     </>
//                   ) : (
//                     <>
//                       <Link
//                         to="/login"
//                         className="flex items-center gap-2 mb-2 text-base-600"
//                       >
//                         <FaSignInAlt /> Login
//                       </Link>
//                       <Link
//                         to="/signup"
//                         className="flex items-center gap-2 mb-2 text-base-600"
//                       >
//                         <FaUserPlus /> Signup
//                       </Link>
//                     </>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* 🔍 Search Icon */}
//             <FaSearch
//               className="cursor-pointer hover:text-red-600"
//               title="Search"
//               onClick={() => setSearchOpen(true)}
//             />

//             {/* Search Modal */}
//             <SearchModal
//               isOpen={searchOpen}
//               onClose={() => setSearchOpen(false)}
//             />

//             {/* ❤️ Wishlist */}
//             {token && (
//               <div
//                 onClick={() => setWishlistOpen(true)}
//                 className="relative flex items-center cursor-pointer"
//                 title="Wishlist"
//               >
//                 <FaHeart className="cursor-pointer hover:text-red-600" />
//                 {wishlistCount > 0 && (
//                   <span className="absolute -top-2 -right-1 bg-red-600 text-white text-xs rounded-full px-1">
//                     {wishlistCount}
//                   </span>
//                 )}
//               </div>
//             )}

//             <WishlistDrawer
//               isOpen={wishlistOpen}
//               onClose={() => setWishlistOpen(false)}
//             />

//             {/* 🛍️ Cart */}
//             <div
//               onClick={() => setCartOpen(true)}
//               className="relative flex items-center cursor-pointer"
//               title="Cart"
//             >
//               <FaShoppingBag className="cursor-pointer hover:text-red-600 ms-3" />
//               <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full px-1">
//                 {cartCount}
//               </span>
//             </div>

//             {/* 🛒 Cart Drawer */}
//             <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
//           </div>
//         </div>
//       </header>

//       {/* 📱 Mobile Menu Drawer */}
//       <MobileNavbar
//         menuOpen={menuOpen}
//         setMenuOpen={setMenuOpen}
//         menuData={menuData}
//         loadingMenu={loadingMenu}
//         menuError={menuError}
//       />
//     </>
//   );
// };

// export default Navbar;

import React, { useState, useEffect, useRef } from "react";
import {
  FaUser,
  FaSearch,
  FaHeart,
  FaShoppingBag,
  FaBars,
  FaSignInAlt,
  FaUserPlus,
  FaSignOutAlt,
  FaBoxOpen,
  FaTachometerAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useMenu } from "../../context/MenuContext"; // ✅ use global MenuContext
// import Logo from "../../../assets/images/logo/TYKA LOGO.png";
import CartDrawer from "../cartpage/CartDrawer";
import MegaMenu from "../mens/MegaMenu";
import MegaMenuCricket from "../cricket/MegaMenuCricket";
import MobileNavbar from "./MobileNavbar";
import WishlistDrawer from "../../common/cartpage/WishlistDrawer";
import SearchModal from "./SearchModal"; // create this component

const Navbar = () => {
  const [menuData, setMenuData] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [loadingMenu, setLoadingMenu] = useState(true);
  const [menuError, setMenuError] = useState(null);
  const [wishlistOpen, setWishlistOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const { cartCount, wishlistCount, fetchMenuCounts } = useMenu();
  const { token, userName, logout } = useAuth();
  const user = JSON.parse(localStorage.getItem("authUserId"));
  const id = user;
  const [logoUrl, setLogoUrl] = useState(null);

  const hideTimeoutRef = useRef(null);
  const menuHideTimeoutRef = useRef(null);

  const handleMouseEnter = () => {
    clearTimeout(hideTimeoutRef.current);
    setShowUserDropdown(true);
  };

  const handleMouseLeave = () => {
    hideTimeoutRef.current = setTimeout(() => {
      setShowUserDropdown(false);
    }, 500);
  };

  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuMouseEnter = (categoryId) => {
    clearTimeout(menuHideTimeoutRef.current);
    setActiveMenu(categoryId);
  };

  const handleMenuMouseLeave = () => {
    menuHideTimeoutRef.current = setTimeout(() => {
      setActiveMenu(null);
    }, 300);
  };

  // 🔹 Fetch menu & counts once
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        setLoadingMenu(true);
        setMenuError(null);

        const res = await fetch(
          `https://tyka.premierhostings.com/backend/api/menu${
            id ? `?id=${id}` : ""
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
          }
        );
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();

        // ✅ Set logo from settings
        if (data.settings && data.settings.logo) {
          setLogoUrl(data.settings.logo);
        }

        setMenuData(data.data || []);
        // ✅ update global counts
        fetchMenuCounts(id, token);
      } catch (err) {
        setMenuError("Failed to load menu");
      } finally {
        setLoadingMenu(false);
      }
    };
    fetchMenu();
  }, [id, token, fetchMenuCounts]);

  return (
    <>
      <header className="shadow-md sticky top-0 z-50 bg-white">
        <div className="max-w-[1747px] mx-auto flex items-center justify-between px-4 py-3 md:px-6 md:py-4">
          {/* Logo */}
          <div className="flex items-center mr-4 md:mr-10">
            <Link to="/">
              <img
                src={logoUrl || "/fallback-logo.png"} // optional fallback if API fails
                alt="Logo"
                className="h-10 w-[115px] md:h-12 md:w-40"
                title="Tyka"
              />
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <div className="lg:hidden">
            <button onClick={() => setMenuOpen(true)}>
              <FaBars size={22} />
            </button>
          </div>

          {/* Desktop Navigation */}
          {/* <nav className="hidden md:flex items-center space-x-10 text-sm font-semibold"> */}
          <nav className="hidden lg:flex items-center space-x-10 text-sm font-semibold">
            <Link
              to="/newarrival"
              className="hover:text-red-600"
              title="new arrivals"
            >
              NEW ARRIVALS
            </Link>

            {menuData.map((category) => {
              const name = category.name.toUpperCase();
              const subcategories = category.subcategories;

              return (
                <div
                  key={category.id}
                  className="relative"
                  onMouseEnter={() => handleMenuMouseEnter(category.id)}
                  onMouseLeave={handleMenuMouseLeave}
                >
                {/*
                  <a href="" className="hover:text-red-600 flex items-center">
                    {name}
                    {subcategories.length > 0 && (
                      <span className="ml-1">▾</span>
                    )}
                  </a>*/}
                  <Link
                    to={`/category/${category.slug}/products`}
                    className="hover:text-red-500 transition flex items-center"
                  >
                    {name}
                    {subcategories.length > 0 && (
                      <span className="ml-1">▾</span>
                    )}
                  </Link>

                  {activeMenu === category.id &&
                    (subcategories.length >= 3 ? (
                      <MegaMenu subcategories={subcategories} category={name} />
                    ) : subcategories.length >= 1 ? (
                      <MegaMenuCricket
                        subcategories={subcategories}
                        category={name}
                      />
                    ) : null)}
                </div>
              );
            })}

            <Link
              to="/design-your-own"
              className="hover:text-red-600"
              title="DESIGN YOUR OWN"
            >
              DESIGN YOUR OWN
            </Link>
          </nav>

          {/* Right Icons */}
          {/* <div className="hidden md:flex items-center space-x-7 text-sm relative"> */}
          <div className="hidden lg:flex items-center space-x-7 text-sm relative">
            {/* 👤 USER DROPDOWN */}
            <div
              className="relative"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {/* <div className="flex items-center space-x-2 cursor-pointer hover:text-red-600">
                <FaUser />
                {token && (
                  <span className="text-sm font-medium" title={`${userName}`}>
                    {userName}
                  </span>
                )}
              </div> */}
              <div className="flex  items-center space-x-2 cursor-pointer hover:text-red-600">
                <FaUser />
                {token ? (
                  <span className="text-sm font-medium" title={userName}>
                    {userName}
                  </span>
                ) : (
                  <span className="text-xs text-gray-500">Sign in</span>
                )}
              </div>

              {showUserDropdown && (
                <div
                  className="absolute bg-white shadow-md p-4 right-0 top-11 z-50"
                  style={{ width: "200px", marginRight: "-55px" }}
                >
                  {token ? (
                    <>
                      <p className="text-sm font-medium mb-4 flex items-center gap-2">
                        Hi, {userName || "User"}!
                      </p>
                      <Link
                        to={`/userdashboard`}
                        className="flex items-center gap-2 mb-2 text-base"
                        title="Dashboard"
                      >
                        <FaTachometerAlt /> Dashboard
                      </Link>
                      <Link
                        to={`/userorder`}
                        className="flex items-center gap-2 mb-2 text-base"
                        title="Orders"
                      >
                        <FaBoxOpen /> Orders
                      </Link>
                      <Link
                        to={`/userprofile`}
                        className="flex items-center gap-2 mb-2 text-base"
                        title="Profile"
                      >
                        <FaUser /> Profile
                      </Link>
                      <button
                        onClick={logout}
                        className="flex items-center gap-2 text-base text-red-400"
                        title="Logout"
                      >
                        <FaSignOutAlt /> Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <Link
                        to="/login"
                        className="flex items-center gap-2 mb-2 text-base-600"
                      >
                        <FaSignInAlt /> Login
                      </Link>
                      <Link
                        to="/signup"
                        className="flex items-center gap-2 mb-2 text-base-600"
                      >
                        <FaUserPlus /> Signup
                      </Link>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* 🔍 Search Icon */}
            <FaSearch
              className="cursor-pointer hover:text-red-600"
              title="Search"
              onClick={() => setSearchOpen(true)}
            />

            {/* Search Modal */}
            <SearchModal
              isOpen={searchOpen}
              onClose={() => setSearchOpen(false)}
            />

            {/* ❤️ Wishlist */}
            {token && (
              <div
                onClick={() => setWishlistOpen(true)}
                className="relative flex items-center cursor-pointer"
                title="Wishlist"
              >
                <FaHeart className="cursor-pointer hover:text-red-600" />
                {wishlistCount > 0 && (
                  <span className="absolute -top-2 -right-1 bg-red-600 text-white text-xs rounded-full px-1">
                    {wishlistCount}
                  </span>
                )}
              </div>
            )}

            <WishlistDrawer
              isOpen={wishlistOpen}
              onClose={() => setWishlistOpen(false)}
            />

            {/* 🛍️ Cart */}
            {/* <div
              onClick={() => setCartOpen(true)}
              className="relative flex items-center cursor-pointer"
              title="Cart"
            >
              <FaShoppingBag className="cursor-pointer hover:text-red-600 ms-3" />
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full px-1">
                {cartCount}
              </span>
            </div> */}
            <div
              onClick={() => setCartOpen(true)}
              className="relative flex flex-col items-center cursor-pointer"
              title="Cart"
            >
              <FaShoppingBag className="cursor-pointer hover:text-red-600 ms-2 mt-4" />

              {/* Badge */}
              <span className="absolute mt-2 -right-2 bg-red-600 text-white text-xs rounded-full px-1">
                {cartCount}
              </span>

              {/* Icon ke niche text */}
              <span className="text-xs text-gray-500 ">Cart</span>
            </div>

            {/* 🛒 Cart Drawer */}
            <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
          </div>
        </div>
      </header>

      {/* 📱 Mobile Menu Drawer + Bottom Bar */}
      <MobileNavbar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        menuData={menuData}
        loadingMenu={loadingMenu}
        menuError={menuError}
        cartCount={cartCount}
        wishlistCount={wishlistCount}
        wishlistOpen={wishlistOpen}
        setWishlistOpen={setWishlistOpen}
        searchOpen={searchOpen}
        setSearchOpen={setSearchOpen}
        cartOpen={cartOpen}
        setCartOpen={setCartOpen}
        token={token}
        userName={userName}
        logout={logout}
      />
    </>
  );
};

export default Navbar;
